import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    TPI_PRODUCT,
    TPI_SUPPLIER,
    TPI_DELIVERY_ORDER,
    TPI_STATUS_DOCS,
    TPI_LIST,
    TPI_EDIT,
    TPI_MTO_DETAIL,
    TPI_EDIT_MTO,
    TPI_PROJECTION_MAINTENANCE_DATES,
    TPI_DOCUMENTATION
} from "../../actions";

import {
    TPIProductSuccess,
    TPIProductError,
    TPISupplierSuccess,
    TPISupplierError,
    TPIDeliveryOrderSuccess,
    TPIDeliveryOrderError,
    TPIStatusDocsSuccess,
    TPIStatusDocsError,
    TPIListSuccess,
    TPIListError,
    TPIEditSuccess,
    TPIEditError,
    TPIMtoDetailSuccess,
    TPIMtoDetailError,
    TPIEditMtoSuccess,
    TPIEditMtoError,
    TPIProjectionMaintenanceDatesSuccess,
    TPIProjectionMaintenanceDatesError,
    TPIDocumentationSuccess,
    TPIDocumentationError,
} from '../../actions';

export function* watchTPIProduct() {
    yield takeEvery(TPI_PRODUCT, onTPIProduct);
}

export function* watchTPISupplier() {
    yield takeEvery(TPI_SUPPLIER, onTPISupplier);
}

export function* watchTPIDeliveryOrder() {
    yield takeEvery(TPI_DELIVERY_ORDER, onTPIDeliveryOrder);
}

export function* watchTPIStatusDocs() {
    yield takeEvery(TPI_STATUS_DOCS, onTPIStatusDocs);
}

export function* watchTPIList() {
    yield takeEvery(TPI_LIST, onTPIList);
}

export function* watchTPIEdit() {
    yield takeEvery(TPI_EDIT, onTPIEdit);
}

export function* watchTPIMtoDetail() {
    yield takeEvery(TPI_MTO_DETAIL, onTPIMtoDetail);
}

export function* watchTPIEditMto() {
    yield takeEvery(TPI_EDIT_MTO, onTPIEditMto);
}

export function* watchTPIProjectionMaintenanceDates() {
    yield takeEvery(TPI_PROJECTION_MAINTENANCE_DATES, onTPIProjectionMaintenanceDates);
}
export function* watchTPIDocumentation() {
    yield takeEvery(TPI_DOCUMENTATION, onTPIDocumentation);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onTPIProductAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'trackingpostinstallation/product', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onTPISupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'trackingpostinstallation/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onTPIDeliveryOrderAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'trackingpostinstallation/deliveryorder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onTPIStatusDocsAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'trackingpostinstallation/statusdocs', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onTPIListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'trackingpostinstallation/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onTPIEditAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'trackingpostinstallation/edit', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onTPIMtoDetailAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'trackingpostinstallation/maintenancedetail', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onTPIEditMtoAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'trackingpostinstallation/editmaintenance', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onTPIProjectionMaintenanceDatesAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'trackingpostinstallation/projectionmaintenancedates', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onTPIDocumentationAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'trackingpostinstallation/documenttraininglist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onTPIProduct(data) {
    try {
        const response = yield call(onTPIProductAsync, data.payload);
        yield put(TPIProductSuccess(response.data));
    } catch (error) {
        yield put(TPIProductError(error));
    }
}

function* onTPISupplier(data) {
    try {
        const response = yield call(onTPISupplierAsync, data.payload);
        yield put(TPISupplierSuccess(response.data));
    } catch (error) {
        yield put(TPISupplierError(error));
    }
}

function* onTPIDeliveryOrder(data) {
    try {
        const response = yield call(onTPIDeliveryOrderAsync, data.payload);
        yield put(TPIDeliveryOrderSuccess(response.data));
    } catch (error) {
        yield put(TPIDeliveryOrderError(error));
    }
}

function* onTPIStatusDocs(data) {
    try {
        const response = yield call(onTPIStatusDocsAsync, data.payload);
        yield put(TPIStatusDocsSuccess(response.data));
    } catch (error) {
        yield put(TPIStatusDocsError(error));
    }
}

function* onTPIList(data) {
    try {
        const response = yield call(onTPIListAsync, data.payload);
        yield put(TPIListSuccess(response.data));
    } catch (error) {
        yield put(TPIListError(error));
    }
}

function* onTPIEdit(data) {
    try {
        const response = yield call(onTPIEditAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(TPIEditSuccess(response.data));
    } catch (error) {
        yield put(TPIEditError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onTPIMtoDetail(data) {
    try {
        const response = yield call(onTPIMtoDetailAsync, data.payload);
        yield put(TPIMtoDetailSuccess(response.data));
    } catch (error) {
        yield put(TPIMtoDetailError(error));
    }
}

function* onTPIEditMto(data) {
    try {
        const response = yield call(onTPIEditMtoAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(TPIEditMtoSuccess(response.data));
    } catch (error) {
        yield put(TPIEditMtoError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onTPIProjectionMaintenanceDates(data) {
    try {
        const response = yield call(onTPIProjectionMaintenanceDatesAsync, data.payload);
        yield put(TPIProjectionMaintenanceDatesSuccess(response.data));
    } catch (error) {
        yield put(TPIProjectionMaintenanceDatesError(error));
    }
}

function* onTPIDocumentation(data) {
    try {
        const response = yield call(onTPIDocumentationAsync, data.payload);
        yield put(TPIDocumentationSuccess(response.data));
    } catch (error) {
        yield put(TPIDocumentationError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchTPIProduct),
        fork(watchTPISupplier),
        fork(watchTPIDeliveryOrder),
        fork(watchTPIStatusDocs),
        fork(watchTPIList),
        fork(watchTPIEdit),
        fork(watchTPIMtoDetail),
        fork(watchTPIEditMto),
        fork(watchTPIProjectionMaintenanceDates),
        fork(watchTPIDocumentation),
    ]);
}